/*
Spannsatz: hier haben wir keine Übersichtseite. Daher wäre es sinnvoll, stattdessen auf die Seiten zu Steilkegel, HSK, PSC und KM4X zu verweisen. Die entsprechenden Begriffe finden sich alle im betreffenden Textabschnitt.
Einbauspannkopf: auch hierzu gibt es keine passende Unterseite. Wir haben aber ein Video, auf das wir verweisen können: https://infothek.ott-jakob.de/files/frame.php?video=GETRIEBE.mp4 (wir schalten den ext. Zugriff für diese Datei frei)
*/

const hotspotsDataArray = [
	{
		name: 'Power-Check',
		x: -0.825,
		y: 0.025,
		z: 0.1,
		info: {
			hl: 'Power-check',
			text: 'Tool clamping systems are exposed to heavy mechanical loads. It is unavoidable that the tool pull-in force decreases over time. If the pull-in force falls below a specified threshold value without being noticed, there is a risk of rejects or, in the worst case, even machine failure. The Power-Check from OTT-JAKOB is designed for checking the pull-in force of tool clamping systems. Thanks to the base units with optimally matched measuring ranges and exchangeable adapters, OTT-JAKOB offers the right pull-force measuring device for every standard tool interface.',
			imgSrc: './assets/img/oj-01-powercheck-mit-adapter.jpeg',
			isVideo: false,
			link: 'https://www.ott-jakob.de/en/power-check/'
		},
		animateTo: {
			position: {
				x: 0.8,
				y: 0.3,
				z: 0.8,
			},
			rotation: {
				x: 0.25,
				y: 0.5,
				z: 0.25,
			},
		},
		mobileAnimateTo: {
			position: {
				x: 0.8,
				y: 0.25,
				z: 0.6,
			},
			rotation: {
				x: 0.25,
				y: 0.5,
				z: 0.25,
			},
		},
	},

	{
		name: 'Clamping Unit',
		x: -0.325,
		y: 0,
		z: 0.1,
		info: {
			hl: 'Clamp&shy;ing Unit',
			text: 'The clamping unit connects the drawbar system and thus the spindle with the tool holder. The clamping unit must clamp the tool securely for many clamping cycles. At OTT-JAKOB you will find the ideal clamping unit for all your requirements, whether grippers with holder for steep tapers (SK) or clamping units for HSK, PSC and KM4XTM interfaces. Thanks to our product diversity, we can also meet special requirements such as higher transmission ratio, high pressure coolants, frequent tool changes or compact designs for use in short spindles.',
			imgSrc: './assets/img/oj-02-spannsatz.jpeg',
			isVideo: false,
			more: {
				title: 'READ MORE',
				buttons: [
					{
						text: 'STEEP TAPER',
						link: 'https://www.ott-jakob.de/en/steep_taper/',
					},
					{
						text: 'HSK',
						link: 'https://www.ott-jakob.de/en/hsk/',
					},
					{
						text: 'PSC',
						link: 'https://www.ott-jakob.de/en/psc/',
					},
					{
						text: 'KM4X™',
						link: 'https://www.ott-jakob.de/en/km4x/',
					},
				],
			},
		},
		animateTo: {
			position: {
				x: 0.29,
				y: 0,
				z: 1.5,
			},
			rotation: {
				x: 0.25,
				y: Math.PI / 8,
				z: 0,
			},
		},
		mobileAnimateTo: {
			position: {
				x: 0.375,
				y: 0,
				z: 1.25,
			},
			rotation: {
				x: 0.25,
				y: Math.PI / 8,
				z: 0,
			},
		},
	},

	{
		name: 'Pulling Head',
		x: 0.115,
		y: 0.005,
		z: 0.05,

		info: {
			hl: 'Pul&shy;ling Head',
			text: 'OTT-JAKOB develops customised pulling heads for every application. The pulling head is the heart of our complete clamping systems. We design pulling heads individually, taking into account the available space of the respective spindle as well as the requirements for pull-in force, speed, required media and service life.',
			imgSrc: './assets/img/oj-03-einbauspannkopf.jpeg',
			isVideo: false,
			link: 'https://www.ott-jakob.de/en/steep_taper/#ausfuehrungen',
		},
		animateTo: {
			position: {
				x: -0.2,
				y: 0,
				z: 0.75,
			},
			rotation: {
				x: 0.25,
				y: 0,
				z: 0,
			},
		},
		mobileAnimateTo: {
			position: {
				x: -0.2,
				y: -0.05,
				z: 0.5,
			},
			rotation: {
				x: 0.35,
				y: 0,
				z: 0,
			},
		},
	},

	{
		name: 'Assistance System MSU',
		x: 0.85,
		y: 0.045,
		z: 0.05,
		info: {
			hl: 'As&shy;sis&shy;tan&shy;ce Sys&shy;tem MSU',
			text: 'The Multi-Sensor Unit (MSU) is a monitoring solution that ensures a controlled production process. The main features are monitoring drawbar position and detecting unclamp unit piston position. The IO-Link capable MSU can be integrated into OTT-JAKOB unclamp units and 2-channel rotary unions as required along with other output signal options. ',
			imgSrc: './assets/img/oj-04-msu.jpeg',
			isVideo: false,
			link: 'https://www.ott-jakob.de/en/msu/',
		},
		animateTo: {
			position: {
				x: -0.75,
				y: 0,
				z: 1.35,
			},
			rotation: {
				x: 0.25,
				y: -0.25,
				z: 0,
			},
		},
		mobileAnimateTo: {
			position: {
				x: -0.55,
				y: -0.175,
				z: 1.75,
			},
			rotation: {
				x: 0.25,
				y: 0.75,
				z: 0,
			},
		},
	},

	{
		name: 'Unclamping Unit',
		x: 0.95,
		y: -0.125,
		z: 0.05,
		info: {
			hl: 'Un&shy;clam&shy;ping Unit',
			text: 'The unclamping unit is a vital component with which the clamping system is released and the tool is ejected. OTT-JAKOB offers a wide range of hydraulic and pneumatic unclamping units for this purpose. Options such as bearing relief and mounting for GD rotary unions allow perfect adaptation to every customer requirement. If required, we integrate the MSU sensor system into the unclamping unit, where it is protected in the best possible way. If desired, monitoring can also be carried out via IO-Link.',
			imgSrc: './assets/img/oj-05-loeseeinheit.jpeg',
			isVideo: false,
			link: 'https://www.ott-jakob.de/en/unclamping_units/',
		},
		animateTo: {
			position: {
				x: -0.7,
				y: -0.05,
				z: 1.65,
			},
			rotation: {
				x: 0.25,
				y: 0.5,
				z: 0,
			},
		},
		mobileAnimateTo: {
			position: {
				x: -0.7,
				y: -0.175,
				z: 1.25,
			},
			rotation: {
				x: 0.25,
				y: 0.5,
				z: 0,
			},
		},
	},

	{
		name: 'Rotary Union',
		x: 1.15,
		y: -0.02,
		z: 0.05,
		info: {
			hl: 'Ro&shy;ta&shy;ry Uni&shy;on',
			text: 'The rotary union transfers liquid or gaseous media from a stationary to a rotating component. OTT-JAKOB offers 1- and 2-channel rotary unions (with an unclamp function) in standard as well as numerous special variants. <br /><br />The OTT-JAKOB rotary union range includes solutions for all common media such as hydraulics, air coolant, MQL, internal spindle cooling and CO₂ for cryogenic machining.<br /><br />Our GD rotary unions offer a special plus when it comes to safety. With their permanently closed sealing surfaces, they reduce unwanted leakage to a minimum and thus prevent moisture-related damage to the spindle.',
			imgSrc: './assets/img/oj-06-drehdurchfu204136hrung.jpeg',
			isVideo: false,
			link: 'https://www.ott-jakob.de/en/rotary_union/',
		},
		animateTo: {
			position: {
				x: -0.7,
				y: 0,
				z: 0.75,
			},
			rotation: {
				x: 0,
				y: -Math.PI / 4,
				z: 0,
			},
		},
		mobileAnimateTo: {
			position: {
				x: -0.75,
				y: -0.025,
				z: 0.6,
			},
			rotation: {
				x: 0,
				y: -Math.PI / 4,
				z: 0,
			},
		},
	},

	{
		name: 'Leakage Sensor',
		x: 1,
		y: -0.35,
		z: 0.05,
		info: {
			hl: 'Le&shy;a&shy;ka&shy;ge Sen&shy;sor',
			text: 'This sensor technology detects possible leakage at the rotary union. The external leakage sensor from OTT-JAKOB is connected to the rotary union via the leakage line and effectively prevents spindle damage that can be caused by flooding with liquid media. If the pre-set flow rate is exceeded, the sensor reports a signal to the machine control PLC.',
			imgSrc: './assets/img/oj-07-ext-leckagesensor.jpeg',
			isVideo: false,
			link: 'https://www.ott-jakob.de/en/condition-monitoring/',
		},
		animateTo: {
			position: {
				x: -1,
				y: 0.35,
				z: 1.75,
			},
			rotation: {
				x: 0,
				y: 0.25,
				z: 0,
			},
		},
		mobileAnimateTo: {
			position: {
				x: -1,
				y: 0.35,
				z: 1.5,
			},
			rotation: {
				x: 0,
				y: 0.25,
				z: 0,
			},
		},
	},
];

export default hotspotsDataArray;
